import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircleOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "var(--main-color)",
		stroke: "none",
		strokeWidth: 1,
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm4.3 7.61l-4.57 6a1 1 0 01-1.58.01l-2.44-3.11a1.001 1.001 0 111.58-1.23l1.63 2.08 3.78-5a1.006 1.006 0 111.6 1.22v.03z",
			fillRule: "nonzero"
		})
	})
});
export { SvgCheckCircleOn as ReactComponent };
